let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("he9IT")).then(() => parcelRequire('6ALbD'));